import { createApi } from '@reduxjs/toolkit/query/react';
import {
	collection,
	doc,
	getDocs,
	GoogleAuthProvider,
	onSnapshot,
	RendernetApiClient,
} from '@rendernet/api-client';

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const fireStoreClient = {
	collection,
	doc,
	getDocs,
	onSnapshot,
};

export const firebaseAuthClient = {
	GoogleAuthProvider,
};

export const client = new RendernetApiClient({
	baseURL: process.env.REACT_APP_BASE_URL,
	firebaseConfig,
});

// Custom baseQuery that uses our RendernetApiClient
const rendernetBaseQuery = () => async (args: any) => {
	try {
		const result = await args.fn(client);
		return { data: result };
	} catch (error) {
		return { error: error.message || 'An error occurred' };
	}
};

export const baseApi = createApi({
	reducerPath: 'api',
	baseQuery: rendernetBaseQuery(),
	endpoints: () => ({}),
	tagTypes: [
		'Models',
		'ModelCategories',
		'ControlNetModels',
		'VideoAnyoneModels',
		'Styles',
		'StyleCategories',
		'Loras',
		'LoraCategories',
		'TrueTouchCost',
		'UpscaleCost',
		'LipSyncCost',
		'FaceReplaceCost',
		'VideoAnyoneCost',
		'VideoSwapCost',
		'MusicVideoCost',
		'Voices',
		'ApiKeyGenerate',
		'ApiKeyReset',
		'Assets',
		'Templates',
		'Characters',
		'UserProfile',
		'Media',
		'SubscriptionPlans',
		'ClothingChangeCost',
	],
});
